/** @file Hook: the pivot hints shown in the review, re-seeded from each request under review. */
import { useState } from 'react';
import type { AnalysisRequest, Pivots } from './autorigTypes';

/** Starts from the request's own hints and starts over when another request (or none) is under review. */
export function usePivotHints(request: AnalysisRequest | null): readonly [Pivots, (next: Pivots) => void] {
  const [pivots, setPivots] = useState<Pivots>(request?.pivots ?? {});
  const [seen, setSeen] = useState(request);
  if (seen !== request) {
    setSeen(request);
    setPivots(request?.pivots ?? {});
  }
  return [pivots, setPivots];
}
